import { render, staticRenderFns } from "./CollegeVerification.vue?vue&type=template&id=4d128cde&"
import script from "./CollegeVerification.vue?vue&type=script&lang=js&"
export * from "./CollegeVerification.vue?vue&type=script&lang=js&"
import style0 from "./CollegeVerification.vue?vue&type=style&index=0&id=4d128cde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports